export default ({ app: { router } }) => {
    router.afterEach((to) => {
      /* 告诉增加一个PV */
      try {
        window._hmt = window._hmt || []
        window._hmt.push(['_trackPageview', to.fullPath])
      } catch (e) {}
    })
  }